import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";

export const getDreamCasinoGames = createAsyncThunk(
  "getDreamCasinoGames/getDreamCasinoGames",
  async (payload, thunkAPI) => {
    
    try {
      console.log("payload", payload, 73)
      const response = await api.post("dream_casino/get-game-list", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const getDreamCasinoGamesSlice = createSlice({
  name: "getDreamCasinoGames",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDreamCasinoGames.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDreamCasinoGames.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDreamCasinoGames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getDreamCasinoGamesSlice.reducer;
